export default "__VITE_ASSET__dmXqYz0d__"